import { useState } from 'react';
import { dataGridPremiumColumns } from '../../utils/helper';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

const TaskListReportsTable = ({ reports, setDeleteDialog }) => {
  const [rowModesModel, setRowModesModel] = useState({});

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'nickName',
      headerName: 'Név',
      type: 'string',
      renderCell: (data) => {
        return data?.row.user.nickName;
      },
    },
    {
      field: 'startDate',
      type: 'date',
      headerName: 'Kezdő dátum',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.startDate).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'endDate',
      type: 'date',
      headerName: 'Befejező dátum',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.endDate).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'timeSpent',
      headerName: 'Ráfordítás',
      type: 'number',
    },
    {
      field: 'description',
      headerName: 'Megjegyzés',
      type: 'string',
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: '',
      cellClassName: 'actions',
      sortable: false,
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              setDeleteDialog((prev) => ({
                ...prev,
                open: true,
                id,
              }));
            }}
            color="inherit"
          />,
        ];
      },
    },
  ]);

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <DatagridPremiumUi
            datagridIdentifier={DataGridIdentifiers.TaskListReportsTable}
            height={400}
            columns={columns}
            rows={reports ?? []}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            headerFilters={false}
            onCellDoubleClick={(_params, event) => {
              event.defaultMuiPrevented = true;
            }}
            slots={{
              toolbar: '',
            }}
            getRowHeight={() => 'auto'}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskListReportsTable;
